export enum RiskIndexNarrativePermission {
  countryRisk = 'country-risk',
  industryRisk = 'industry-risk',
  commodity = 'commodity',
}
